import { ca } from '@cian/analytics';

import { IPageState } from '../../types/page';
import { TUser } from '../../types/user';
import { IProduct, getPageNumber } from '../../utils/trackings';

export function trackFavoriteRemove(
  pageData: IPageState,
  user: TUser,
  label: string,
  product: IProduct,
  total: number,
) {
  ca('eventEbc', {
    name: 'oldevent',
    category: 'favorite',
    action: 'remove_from_favorites',
    label,
    user: {
      isAuthorized: user.isAuthenticated,
      userId: user.isAuthenticated ? user.userId : undefined,
    },
    page: {
      listingType: 'list',
      sortType: 'default',
      pageNumber: getPageNumber(total, product.position),
      offersQty: total,
      pageType: 'ListingFavorites',
      siteType: pageData.deviceType === 'phone' ? 'mobile' : pageData.deviceType,
    },
    products: [product],
  });
}
